import _isEmpty from 'lodash/isEmpty';
import { useNavigate, useLocation } from 'react-router-dom';

function useQueryParams(query) {
  const navigate = useNavigate();
  const location = useLocation();

  if (typeof window === 'undefined') {
    return { get: () => null, set: () => {}, push: () => {} };
  }

  const get = () => {
    if (_isEmpty(query)) {
      return null;
    }

    const params = new URLSearchParams(location.search);
    return params.get(query);
  };

  function set(value, replace = true) {
    if (_isEmpty(query)) {
      return;
    }

    const params = new URLSearchParams(location.search);
    params.set(query, value);
    const newSearch = params.toString();
    const newPath = `${location.pathname}?${newSearch}`;

    navigate(newPath, { replace });
  }

  function push(value) {
    set(value, false);
  }

  return { get, set, push };
}

export default useQueryParams;
